/**
 * /chats — tela de CHAT estilo Tiflux em 3 colunas (sem scroll de página;
 * cada coluna rola internamente): lista de conversas (320px) | janela do
 * chat | painel do solicitante (300px, colapsável pelo ícone Info).
 */
import { useEffect, useState } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { z } from 'zod';
import type { ChatTab } from '@erp/shared';
import { ChatListPane } from './chat-list-pane';
import { ChatWindow } from './chat-window';
import { ChatInfoPanel } from './chat-info-panel';

const INFO_KEY = 'erp.chats.info-open';

/** `?chat=<id>` (v12): deep link do sino/notificação do SO para UMA conversa.
 *  A seleção continua sendo estado local — o parâmetro só a SEMEIA. */
export const chatsSearchSchema = z.object({
  chat: z.coerce.number().int().positive().optional(),
});

const routeApi = getRouteApi('/_authenticated/chats');

export function ChatsPage() {
  const { chat: chatParam } = routeApi.useSearch();
  const [tab, setTab] = useState<ChatTab>('inbox');
  const [selectedId, setSelectedId] = useState<number | null>(chatParam ?? null);

  // Clique numa notificação com a /chats JÁ montada: o componente não remonta,
  // então é a mudança do parâmetro que troca a conversa aberta.
  useEffect(() => {
    if (chatParam !== undefined) setSelectedId(chatParam);
  }, [chatParam]);

  const [infoOpen, setInfoOpen] = useState(() => localStorage.getItem(INFO_KEY) !== '0');

  const toggleInfo = () =>
    setInfoOpen((prev) => {
      localStorage.setItem(INFO_KEY, prev ? '0' : '1');
      return !prev;
    });

  // 100dvh − topbar (3rem) − padding do main (2rem) = altura útil da tela.
  return (
    <div className="flex h-[calc(100dvh-5rem)] min-h-[420px] gap-4">
      <ChatListPane tab={tab} onTabChange={setTab} selectedId={selectedId} onSelect={setSelectedId} />
      <ChatWindow
        chatId={selectedId}
        infoOpen={infoOpen}
        onToggleInfo={toggleInfo}
        onClearSelection={() => setSelectedId(null)}
        onSelectChat={setSelectedId}
      />
      {selectedId !== null && infoOpen ? (
        <ChatInfoPanel chatId={selectedId} onSelectChat={setSelectedId} />
      ) : null}
    </div>
  );
}
